import { get } from '../../utils/http'

export const getCategories = (type = 1, parentId = 0, param) => get(`/xbag/college/category/${type}/${parentId}/gets`, param, true)
export const getProfession = (param) => get(`/xbag/college/job/gets`, param, true)
export const getDetail = (id) => get(`/xbag/college/job/id/${id}`, {}, true)



// WEBPACK FOOTER //
// ./src/api/profession/index.js